var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import { Injectable } from '@angular/core';
var CaratteriInfoService = /** @class */ (function () {
    function CaratteriInfoService() {
        this.allineamenti = [
            {
                icon: 'alignleft',
                appereance: 'left',
                hint: 'Allinea a Sinistra',
            },
            {
                icon: 'aligncenter',
                appereance: 'center',
                hint: 'Allinea al Centro',
            },
            {
                icon: 'alignright',
                appereance: 'right',
                hint: 'Allinea a Destra',
            },
            {
                icon: 'alignjustify',
                appereance: 'justify',
                hint: 'Giustifica il Testo',
            },
        ];
        this.aspetti = [
            {
                icon: 'bold',
                appereance: 'bold',
                hint: 'Bold',
            },
            {
                icon: 'italic',
                appereance: 'italic',
                hint: 'Italic',
            },
            {
                icon: 'underline',
                appereance: 'underline',
                hint: 'Underlined',
            },
            {
                icon: 'strike',
                appereance: 'strike',
                hint: 'Strikethrough',
            },
        ];
    }
    CaratteriInfoService.prototype.getAltezzeFont = function () {
        var ris = [];
        var primaAltezza = 5;
        for (var i = 0; i < 29; i++) {
            if (primaAltezza >= 5 && primaAltezza < 12) {
                ris.push(primaAltezza);
                primaAltezza++;
                continue;
            }
            else if (primaAltezza >= 12 && primaAltezza < 28) {
                ris.push(primaAltezza);
                primaAltezza = primaAltezza + 2;
                continue;
            }
            else if (primaAltezza >= 28 && primaAltezza <= 64) {
                ris.push(primaAltezza);
                primaAltezza = primaAltezza + 4;
                continue;
            }
        }
        ris.push(72);
        return ris;
    };
    CaratteriInfoService.prototype.getFamiglieFont = function () {
        //let fonts= 'Arial|Verdana|Tahoma|Trebuchet MS|Helvetica Neue|Times New Roman|Courier|Times New Roman|Comic Sans MS|Impact|Garamond|Courier New|Brush Script MT'.split('|');
        var fonts = 'Helvetica|Courier|Symbol|Times'.split('|');
        //let fontsDiGoogle = 'Aclonica|Allan|Annie Use Your Telescope|Anonymous Pro|Allerta Stencil|Allerta|Amaranth|Anton|Architects Daughter|Arimo|Artifika|Arvo|Asset|Astloch|Bangers|Bentham|Bevan|Bigshot One|Bowlby One|Bowlby One SC|Brawler|Buda:300|Cabin|Calligraffitti|Candal|Cantarell|Cardo|Carter One|Caudex|Cedarville Cursive|Cherry Cream Soda|Chewy|Coda|Coming Soon|Copse|Corben|Cousine|Covered By Your Grace|Crafty Girls|Crimson Text|Crushed|Cuprum|Damion|Dancing Script|Dawning of a New Day|Didact Gothic|Droid Sans|Droid Serif|EB Garamond|Expletus Sans|Fontdiner Swanky|Forum|Francois One|Geo|Give You Glory|Goblin One|Goudy Bookletter 1911|Gravitas One|Gruppo|Hammersmith One|Holtwood One SC|Homemade Apple|Inconsolata|Indie Flower|Irish Grover|Istok Web|Josefin Sans|Josefin Slab|Judson|Jura|Just Another Hand|Just Me Again Down Here|Kameron|Kenia|Kranky|Kreon|Kristi|La Belle Aurore|Lato|League Script|Lekton|Limelight|Lobster|Lobster Two|Lora|Love Ya Like A Sister|Loved by the King|Luckiest Guy|Maiden Orange|Mako|Maven Pro|Maven Pro:900|Meddon|MedievalSharp|Megrim|Merriweather|Metrophobic|Michroma|Miltonian Tattoo|Miltonian|Modern Antiqua|Monofett|Molengo|Mountains of Christmas|Muli:300|Muli|Neucha|Neuton|News Cycle|Nixie One|Nobile|Nova Cut|Nova Flat|Nova Mono|Nova Oval|Nova Round|Nova Script|Nova Slim|Nova Square|Nunito|Old Standard TT|Open Sans:300|Open Sans|Open Sans:600|Open Sans:800|Open Sans Condensed:300|Orbitron|Orbitron:500|Orbitron:700|Orbitron:900|Oswald|Over the Rainbow|Reenie Beanie|Pacifico|Patrick Hand|Paytone One|Permanent Marker|Philosopher|Play|Playfair Display|Podkova|Press Start 2P|Puritan|Quattrocento|Quattrocento Sans|Radley|Raleway:100|Redressed|Rock Salt|Rokkitt|Ruslan Display|Schoolbell|Shadows Into Light|Shanti|Sigmar One|Six Caps|Slackey|Smythe|Sniglet|Sniglet:800|Special Elite|Stardos Stencil|Sue Elen Francisco|Sunshiney|Swanky and Moo Moo|Syncopate|Tangerine|Tenor Sans|Terminal Dosis Light|The Girl Next Door|Tinos|Ubuntu|Ultra|Unkempt|UnifrakturCook:bold|UnifrakturMaguntia|Varela|Varela Round|Vibur|Vollkorn|VT323|Waiting for the Sunrise|Wallpoet|Walter Turncoat|Wire One|Yanone Kaffeesatz|Yeseva One|Zeyada'.split('|')
        //let fontsMerged = fontsDiSistema.concat(fontsDiGoogle);
        return fonts;
    };
    CaratteriInfoService.prototype.getAllineamenti = function () {
        return this.allineamenti;
    };
    CaratteriInfoService.prototype.getAspetti = function () {
        return this.aspetti;
    };
    CaratteriInfoService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [])
    ], CaratteriInfoService);
    return CaratteriInfoService;
}());
export { CaratteriInfoService };
//# sourceMappingURL=caratteri-info.service.js.map